import { Badge } from '@/components/ui/Badge';
import { Button } from '@/components/ui/Button';
import { useBrowserPool, useRestartBrowserInstance } from '@/hooks/useAdminMonitoring';
import { Skeleton } from '@/components/ui/Skeleton';
import { EmptyState } from '@/components/ui/EmptyState';
import { formatBytes, formatDuration } from '@/utils/formatters';
import { Globe, RotateCcw } from 'lucide-react';

export function BrowserInstancesList() {
  const { data, isLoading } = useBrowserPool();
  const restart = useRestartBrowserInstance();
  // Service returns BrowserInstance[] directly
  const instances = data || [];

  if (isLoading) return <div className="space-y-2"><Skeleton className="h-16" /><Skeleton className="h-16" /></div>;
  if (instances.length === 0) return <EmptyState message="Aucune instance" icon={<Globe className="h-8 w-8" />} />;

  return (
    <div className="space-y-2">
      {instances.map((inst) => (
        <div key={inst.id} className="flex items-center justify-between rounded-lg border border-neutral-200 dark:border-neutral-800 bg-neutral-50 dark:bg-neutral-900/50 p-4">
          <div>
            <p className="text-sm font-medium text-neutral-700 dark:text-neutral-200">Instance #{inst.id?.slice(0, 8)}</p>
            <p className="text-xs text-neutral-500">{inst.currentTask || 'Inactif'} - {formatBytes(inst.memoryUsage)} - {formatDuration(inst.uptime)}</p>
          </div>
          <div className="flex items-center gap-2">
            <Badge variant={inst.status === 'busy' ? 'warning' : inst.status === 'idle' ? 'neutral' : 'success'}>{inst.status}</Badge>
            <Button variant="ghost" size="sm" icon={<RotateCcw className="h-3 w-3" />} onClick={() => restart.mutate(inst.id)} />
          </div>
        </div>
      ))}
    </div>
  );
}
